import { render, staticRenderFns } from "./TextToolbar.vue?vue&type=template&id=c26c42be&scoped=true&"
import script from "./TextToolbar.vue?vue&type=script&lang=ts&"
export * from "./TextToolbar.vue?vue&type=script&lang=ts&"
import style0 from "./TextToolbar.vue?vue&type=style&index=0&id=c26c42be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c26c42be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VTooltip})
